// @ts-check
import React, { useEffect } from "react";

import Loader from "components/loader/Loader";
import { actions } from "actions";
import { connect } from "unistore/preact";
import i18n from "micro-i18n";
import { isNullOrUndef } from "utils";

/**
 * @template T
 * @typedef {import('preact').ComponentType<T>} ComponentType
 */

/**
 * @typedef {import('preact').JSX.Element} JSXElement
 * @typedef {import('types/store').WidgetState} WidgetState
 */

/**
 * @typedef {Object} FinishLoaderProps
 * @property {WidgetState['questionsData']} [questionsData] - Questions data object from store
 * @property {number} [resultResponseCount] - Count of result responses
 * @property {() => void} getFinish - Function to call when loading is complete
 */

/**
 * FinishLoader component that displays a loader while calculating results
 * @param {FinishLoaderProps} props
 * @returns {JSXElement}
 */
const FinishLoader = ({ questionsData, resultResponseCount, getFinish }) => {
  //componentDidUpdate() questionsData and resultResponseCount
  useEffect(() => {
    //NOTE: Due to async nature of getResults and back button addition, resultResponseCount could possibly be
    // greater than the questionsData.sessionLength due to possible race condition if the getResults hits the catch.
    if (!questionsData?.questions) return;
    if (isNullOrUndef(resultResponseCount)) return;
    if (isNullOrUndef(questionsData.sessionLength)) return;
    if (resultResponseCount < questionsData.sessionLength) return;

    getFinish();
  }, [questionsData, resultResponseCount]);

  return <Loader loaderMessage={i18n.t("CALCULATING_RESULTS")} isAnimated={true} />;
};

/** @type {ComponentType<FinishLoaderProps>} */
export default connect("questionsData,resultResponseCount", actions)(FinishLoader);
